/*
 * A class for expressing arguments to interrupt events.
 */
var InterruptArgs = (function () {
    function InterruptArgs(source, innerArgs, force) {
        if (force === void 0) { force = false; }
        this.source = source;
        this.innerArgs = innerArgs;
        this.force = force;
    }
    return InterruptArgs;
}());
export { InterruptArgs };
//# sourceMappingURL=interruptargs.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/@ng-idle/core/src/interruptargs.js
// module id = ../../../../@ng-idle/core/src/interruptargs.js
// module chunks = 4